module.exports = __webpack_public_path__ + "static/media/bwki-competition-logo.68922b53.png";